import { render, staticRenderFns } from "./BaseRadioGroup2.vue?vue&type=template&id=3d9bbc56&scoped=true"
import script from "./BaseRadioGroup2.vue?vue&type=script&lang=js"
export * from "./BaseRadioGroup2.vue?vue&type=script&lang=js"
import style0 from "./BaseRadioGroup2.vue?vue&type=style&index=0&id=3d9bbc56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9bbc56",
  null
  
)

export default component.exports